var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help-black",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "read-copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,24 C18.6274,24 24,18.6274 24,12 C24,5.37258 18.6274,0 12,0 C5.37258,0 0,5.37258 0,12 C0,18.6274 5.37258,24 12,24 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.128,14 L13.128,12.6694387 C13.9066667,12.4255024 14.584,12.009702 15.16,11.4220374 C15.736,10.8454608 16.024,10.1469161 16.024,9.32640333 C16.024,8.28413028 15.6506667,7.47470547 14.904,6.8981289 C14.168,6.2993763 13.2773333,6 12.232,6 C10.9946667,6 9.91733333,6.32709633 9,6.98128898 L9,6.98128898 L9,9.07692308 C10.0026667,8.45599446 10.9573333,8.14553015 11.864,8.14553015 C12.4186667,8.14553015 12.864,8.25918226 13.2,8.48648649 C13.536,8.71379071 13.704,9.04365904 13.704,9.47609148 C13.704,9.95287595 13.4266667,10.3797644 12.872,10.7567568 C12.328,11.1226611 11.6986667,11.3832294 10.984,11.5384615 L10.984,11.5384615 L10.984,14 L13.128,14 Z M12.104,17.6 C12.488,17.6 12.816,17.464 13.088,17.192 C13.36,16.92 13.496,16.5866667 13.496,16.192 C13.496,15.808 13.36,15.4826667 13.088,15.216 C12.816,14.9493333 12.488,14.816 12.104,14.816 C11.7093333,14.816 11.3786667,14.9493333 11.112,15.216 C10.8453333,15.4826667 10.712,15.808 10.712,16.192 C10.712,16.5866667 10.8453333,16.92 11.112,17.192 C11.3786667,17.464 11.7093333,17.6 12.104,17.6 Z",
    id: "?-copy",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBlack);
export default __webpack_public_path__ + "static/media/help-black.2a47f958444bd5202254c5c37f5eb67f.svg";
export { ForwardRef as ReactComponent };